import { useEffect } from "react";
import PropTypes from "prop-types";
import L from "leaflet";
import "leaflet.markercluster/dist/leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import { useLeaflet } from "react-leaflet";
import noImage from 'assets/img/users/no-image.jpg';
const mcg = L.markerClusterGroup();

const MarkerCluster = ({ markers,popup }) => {

  const customMarker = new L.Icon({
    iconUrl: require("../../assets/img/marker-icon.png"),
    iconSize: [25, 41],
    iconAnchor: [10, 41],
    popupAnchor: [2, -40]
  });
  const { map } = useLeaflet();

  useEffect(() => {
    mcg.clearLayers();
    markers.forEach((item) => {
      L.marker(new L.LatLng(item.latitude, item.longitude), {
        icon: customMarker
      })
        .addTo(mcg)
        .bindPopup(`<div>
        <div style="text-align:center;"><img src="${(item.avatar) ? item.avatar : noImage}" class="rounded-circle" style="width:60px;height:60px;"></div>
        <div class="map-user-name"><a href="/#/user-profile/${item.id}">${item.name}</a></div>
        </div>`, {
          closeButton: false,
          closeOnClick: true,
          autoClose: false

        });
        /*if(popup && popup.lat === marker._latlng.lat && popup.lng === marker._latlng.lng){
          marker.openPopup()
        }*/

    }
      //.openPopup()
    );

    // optionally center the map around the markers
    //map.fitBounds(mcg.getBounds());
    // add the marker cluster group to the map
    map.addLayer(mcg);
  }, [markers, map]);
  return null;
};

MarkerCluster.propTypes = {
  markers: PropTypes.arrayOf(
    PropTypes.shape({
      //position: PropTypes.objectOf(PropTypes.number).isRequired,
      //text: PropTypes.string.isRequired
    }).isRequired
  ).isRequired
};

export default MarkerCluster;